import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Logo } from '@els/els-react--logo';
import { LinkElement } from '@els/els-react--link-element';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import LoginPageWrapper from '../../../Components/LoginPageWrapper';

import './ConfirmationEmailSentDialog.scss';

function ConfirmationEmailSentDialog({ email: emailProp, selfClose }) {
  const location = useLocation();
  const email = location?.state?.email || emailProp || '';

  const handleTryAgain = () => {
    if (selfClose) {
      selfClose();
    } else {
      history.goBack();
    }
  };

  const handleRegisterAgain = () => {
    if (selfClose) {
      selfClose();
    }
    history.push({ pathname: paths.REGISTER });
  };

  return (
    <LoginPageWrapper className="react-page-register-confirmation-page" mainAriaLabel="Registration confirmation email screen">
      <div className="confirmation-email-dialog__content">
        <div className="confirmation-email-dialog__header">
          <Logo className="confirmation-email-dialog__logo u-els-padding-bottom-1x1o2" />
          <h1 className="confirmation-email-dialog__title u-els-padding-bottom u-els-font-size-h3">Check your inbox</h1>
        </div>

        <div className="confirmation-email-dialog__body u-els-padding-bottom-2x">
          <p className="confirmation-email-dialog__text">
            Please check the inbox for
            <br />
            <span className="u-els-font-family-bold">{email || '$email_address_provided'}</span>
            <br />
            for instructions to follow.
          </p>

          <p className="confirmation-email-dialog__try-again u-els-margin-top-1x1o2">
            Didn&apos;t receive an email?{' '}
            <LinkElement
              data-e2e="confirmation-email-dialog-try-again"
              className="confirmation-email-dialog__try-again-link"
              href="#"
              isExternal
              noExternalIcon
              onClick={handleTryAgain}>
              Try again
            </LinkElement>
          </p>
        </div>

        <div className="confirmation-email-dialog__divider" />

        <div className="confirmation-email-dialog__footer">
          <p className="confirmation-email-dialog__footer-text">Error in the email address?</p>
          <LinkElement
            data-e2e="confirmation-email-dialog-register-again"
            className="confirmation-email-dialog__register-again"
            href="#"
            isExternal
            noExternalIcon
            onClick={handleRegisterAgain}>
            Register again
          </LinkElement>
        </div>
      </div>
    </LoginPageWrapper>
  );
}

ConfirmationEmailSentDialog.propTypes = {
  email: PropTypes.string,
  selfClose: PropTypes.func,
};

export default ConfirmationEmailSentDialog;
